import React, { Component } from 'react';
import {
  Button,
  ButtonDropdown,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
} from 'reactstrap';
import { QUESTION_MODE, QUESTION_MODE_OPTIONS } from '../common/constant';
import { messages } from '../common/messages';
import post from '../views/RestAPI/fetchData';
import config from '../views/config/App_data';
import { showFailure, showSuccess } from '../common/toast';
import { getQuestionModeFromLocalStorage, setQuestionModeToLocalStorage } from '../common/function';
import TooltipItem from '../common/Tooltip';

export default class QuestionModeSetting extends Component {
  constructor(props) {
    super(props);

    const { examNameKey } = props;
    const selectedMode = getQuestionModeFromLocalStorage(examNameKey) || '';
    this.state = {
      isDropdownOpen: false,
      selectedMode: selectedMode || QUESTION_MODE.PRACTICE,
      isModalOpen: false, // default to closed
      isLoading: false,
    };
  }

  componentDidMount() {
    const { examNameKey } = this.props;
    const selectedMode = getQuestionModeFromLocalStorage(examNameKey) || '';
    this.setState({
      selectedMode: selectedMode || QUESTION_MODE.PRACTICE,
      isModalOpen: !selectedMode, // open modal only if no mode selected
    });
  }

  updateQuestionMode = async (userSelectedMode) => {
    const { selectedMode } = this.state;
    this.setState({ isLoading: true });
    const { examNameKey } = this.props;
    try {
      await post.callAPI(`${config.backend_api}/user/update/question-mode`, {
        userSelectedMode,
        examNameKey,
      });
      // Update localStorage using utility
      setQuestionModeToLocalStorage(examNameKey, userSelectedMode || selectedMode);

      this.setState({
        isModalOpen: false,
        selectedMode: userSelectedMode || selectedMode,
        isLoading: false,
      });
      showSuccess(
        messages.QUESTION_MODE_SAVE_SUCCESS.replace(
          ':mode',
          userSelectedMode === QUESTION_MODE.REVISION
            ? messages.REVISION_MODE
            : messages.PRACTICE_MODE,
        ),
      );
    } catch (error) {
      this.setState({ isLoading: false, isModalOpen: false });
      showFailure(messages.QUESTION_MODE_SAVE_FAILED);
    }
  };

  handleDropdownToggle = () => {
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
  };

  handleRadioChange = (e) => {
    this.setState({ selectedMode: e.target.value });
  };

  render() {
    const { isDropdownOpen, selectedMode, isModalOpen, isLoading } = this.state;
    const userSelectedModeTitle =
      selectedMode === QUESTION_MODE.PRACTICE
        ? messages.PRACTICE_MODE
        : selectedMode === QUESTION_MODE.REVISION
          ? messages.REVISION_MODE
          : messages.SELECT_MODE;

    return (
      <div className='ml-auto'>
        <ButtonDropdown isOpen={isDropdownOpen} toggle={this.handleDropdownToggle}>
          <DropdownToggle
            className='btn btn-primary overflow-hidden pointer_class tooltip_wrap'
            caret
            disabled={isLoading}
          >
            {isLoading && !isModalOpen && <i className='fa fa-spinner fa-spin' />}{' '}
            {userSelectedModeTitle}
          </DropdownToggle>
          <DropdownMenu end className='border-0'>
            <DropdownItem
              onClick={() => this.updateQuestionMode(QUESTION_MODE.PRACTICE)}
              active={selectedMode === QUESTION_MODE.PRACTICE}
              className='pointer_class'
            >
              {messages.PRACTICE_MODE}
              <span className='tooltip_padding'>
                <TooltipItem
                  tooltipId={QUESTION_MODE.PRACTICE}
                  content={messages.PRACTICE_MODE_DESC}
                  width='11'
                />
              </span>
            </DropdownItem>
            <DropdownItem
              onClick={() => this.updateQuestionMode(QUESTION_MODE.REVISION)}
              active={selectedMode === QUESTION_MODE.REVISION}
              className='pointer_class'
            >
              {messages.REVISION_MODE}
              <span className='tooltip_padding'>
                <TooltipItem
                  tooltipId={QUESTION_MODE.REVISION}
                  content={messages.REVISION_MODE_DESC}
                  width='11'
                />
              </span>
            </DropdownItem>
          </DropdownMenu>
        </ButtonDropdown>
        <Modal
          isOpen={isModalOpen}
          className='modal-primary custom-centered-modal'
          centered
          backdrop='static'
        >
          <ModalHeader>
            <span className='pl-0'>{messages.SETTINGS_TITLE}</span>
          </ModalHeader>
          <ModalBody>
            <Row className='mb-1'>
              <Col xs={12} className='font-weight-bold question-mode-title'>
                {messages.QUESTION_BANK_MODE_TYPE}
              </Col>
            </Row>
            {QUESTION_MODE_OPTIONS.map((mode) => (
              <Row key={mode.id} className='mb-1 justify-content-center'>
                <Col sm={10} md={10}>
                  <div className='d-flex '>
                    <div onChange={this.handleRadioChange}>
                      <input
                        className='form-check-input mr-2 pointer_class'
                        type='radio'
                        id={mode.id}
                        name='mode'
                        value={mode.value}
                        checked={selectedMode === mode.value}
                      />
                      <label htmlFor={mode.id} className='font-weight-medium mb-0 pointer_class'>
                        {mode.label}
                        <div className='small pointer_class'>{mode.description}</div>
                      </label>
                    </div>
                  </div>
                </Col>
              </Row>
            ))}
            <Row className='mb-2'>
              <Col className='small'>{messages.MODE_CHANGE_NOTE}</Col>
            </Row>
            <Row>
              <Col className='text-center'>
                <Button
                  color='primary'
                  onClick={() => this.updateQuestionMode(selectedMode)}
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <span>
                      <i className='fa fa-spinner fa-spin' /> {messages.SAVE}
                    </span>
                  ) : (
                    messages.SAVE
                  )}
                </Button>
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionModeSetting.js